import { render } from "./PermissionTree.vue?vue&type=template&id=73bd22aa&scoped=true"
import script from "./PermissionTree.vue?vue&type=script&lang=js"
export * from "./PermissionTree.vue?vue&type=script&lang=js"

import "./PermissionTree.vue?vue&type=style&index=0&id=73bd22aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73bd22aa"]])

export default __exports__